import { request } from '../../helpers/apiHelper'
import { displayNotification } from '../../actions/notificationsActions'
import {
  approveVerificationMutation,
  assignMultipleTasksMutation,
  assignTaskMutation,
  completeTaskMutation,
  createInsurancePolicyMutation,
  rejectVerificationMutation,
  taskQuery,
  tasksQuery,
  updateLienholderMutation,
} from './queries'

export enum TaskActionType {
  FETCH_TASKS_FAILURE = 'FETCH_TASKS_FAILURE',
  FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS',
  FETCH_TASK_FAILURE = 'FETCH_TASK_FAILURE',
  FETCH_TASK_SUCCESS = 'FETCH_TASK_SUCCESS',
  CREATE_INSURANCEPOLICY_FAILURE = 'CREATE_INSURANCEPOLICY_FAILURE',
  CREATE_INSURANCEPOLICY_SUCCESS = 'CREATE_INSURANCEPOLICY_SUCCESS',
  UPDATE_LIENHOLDER_FAILURE = 'UPDATE_LIENHOLDER_FAILURE',
  UPDATE_LIENHOLDER_SUCCESS = 'UPDATE_LIENHOLDER_SUCCESS',
  UPDATE_TASKS_SUCCESS = 'UPDATE_TASKS_SUCCESS',
  UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS',
}

export const fetchTask = (id) => (dispatch) => {
  return request(taskQuery.default, { id })
    .then((response) => {
      const task = response.data.data.task
      dispatch({
        type: TaskActionType.FETCH_TASK_SUCCESS,
        entity: task,
      })
      return task.taskType
    })
    .catch(() => {
      dispatch({
        type: TaskActionType.FETCH_TASK_FAILURE,
      })
      dispatch(displayNotification('Failed to fetch Task', 'error'))
    })
}

export const fetchTasks = (varObject) => (dispatch) => {
  return request(tasksQuery.default, varObject)
    .then((response) => {
      dispatch({
        type: TaskActionType.FETCH_TASKS_SUCCESS,
        entities: response.data.data.tasks.items,
        meta: response.data.data.tasks.meta,
      })
    })
    .catch(() => {
      dispatch({
        type: TaskActionType.FETCH_TASKS_FAILURE,
      })
      dispatch(displayNotification('Failed to fetch Tasks', 'error', 10000))
    })
}

export const completeTask = (id) => (dispatch) => {
  return request(completeTaskMutation.default, { id })
    .then(() => {
      dispatch(displayNotification('Task Completed'))
    })
    .catch(() => {
      dispatch(displayNotification('Task complete failed', 'error', 10000))
    })
}

///////////////////////////////
//POTENTIAL USE FOR FUTURE PR//
///////////////////////////////

// export const updateCarfax = newState => dispatch => {
//   return request(carfaxMutation, { newState })
//     .then(response=> {
//       if (response.data.errors) {
//         throw new Error(response.data.errors[0].message);
//       } else {
//         dispatch({
//           type: 'UPDATE_CARFAX_SUCCESS',
//           entity: response.data.data.updateFraudCheck.fraud_check
//         });
//       }
//     })
//     .catch(error => {
//       dispatch({
//         type: 'UPDATE_CARFAX_ERROR'
//       });
//       dispatch(displayNotification(`Failed to update Carfax Fraud Check: ${error.message}`, 'error'));
//       throw new Error(error);
//     });
// };

export const approveTask =
  (id, comment = null) =>
  (dispatch) => {
    return request(approveVerificationMutation.default, { id, comment })
      .then(() => {
        dispatch(displayNotification('Task Approved'))
      })
      .catch(() => {
        dispatch(displayNotification('Task approval failed', 'error', 10000))
      })
  }

export const rejectTask =
  (id, comment = null, rejectionType = 'SOFT') =>
  (dispatch) => {
    return request(rejectVerificationMutation.default, {
      id,
      comment,
      rejectionType,
    })
      .then(() => {
        dispatch(displayNotification('Task Rejected'))
      })
      .catch(() => {
        dispatch(displayNotification('Task rejection failed', 'error', 10000))
      })
  }

export const assignTask = (taskId, adminId) => (dispatch) => {
  return request(assignTaskMutation.default, {
    id: taskId,
    assigneeId: adminId,
  })
    .then((response) => {
      dispatch({
        type: TaskActionType.UPDATE_TASK_SUCCESS,
        entity: response.data.data.assignTask.task,
      })
      dispatch(displayNotification('Task Assigned'))
    })
    .catch(() => {
      dispatch(displayNotification('Task Assignment Failed', 'error', 10000))
    })
}

export const assignMultipleTasks = (taskIds, adminId) => (dispatch) => {
  return request(assignMultipleTasksMutation.default, {
    ids: taskIds,
    assigneeId: adminId,
  })
    .then((response) => {
      dispatch({
        type: TaskActionType.UPDATE_TASKS_SUCCESS,
        entities: response.data.data.assignTask.tasks,
      })
      dispatch(displayNotification('Task Assigned'))
    })
    .catch(() => {
      dispatch(displayNotification('Task Assignment Failed', 'error', 10000))
    })
}

export const updateLienholder = (newState, id) => (dispatch) => {
  return request(updateLienholderMutation.default, { lienholder: newState })
    .then((response) => {
      if (response.data.errors) {
        throw new Error(response.data.errors[0].message)
      } else {
        const lienholder = response.data.data.updateLienholder.lienholder
        dispatch({
          type: TaskActionType.UPDATE_LIENHOLDER_SUCCESS,
          entity: lienholder,
        })
        dispatch(approveTask(id))
      }
    })
    .catch((error) => {
      dispatch({
        type: TaskActionType.UPDATE_LIENHOLDER_FAILURE,
      })
      dispatch(
        displayNotification(
          `Failed to update Lienholder: ${error.message}`,
          'error'
        )
      )
      throw new Error(error)
    })
}

export const createInsurancePolicy = (policy) => (dispatch) => {
  return request(createInsurancePolicyMutation.default, {
    insurancePolicy: policy,
  })
    .then((response) => {
      if (response.data.errors) {
        throw new Error(response.data.errors[0].message)
      } else {
        const policy = response.data.data.createInsurancePolicy.insurancePolicy
        dispatch({
          type: TaskActionType.CREATE_INSURANCEPOLICY_SUCCESS,
          entity: policy,
        })
      }
    })
    .catch((error) => {
      dispatch({
        type: TaskActionType.CREATE_INSURANCEPOLICY_FAILURE,
      })
      dispatch(
        displayNotification(
          `Failed to create Insurance Policy: ${error.message}`,
          'error'
        )
      )
      throw new Error(error)
    })
}
